"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sqlEscape = exports.sqlString = exports.unnest = exports.splitEscapedString = exports.buildDynamicText = exports.pluralize = exports.plural = exports.spaces = exports.toLength = exports.digits = exports.getTerminalLength = exports.multiplyCssValue = exports.slugify = exports.toPascalCase = exports.toCamelCase = exports.toKebabCase = exports.toSnakeCase = exports.latinize = exports.decapitalize = exports.capitalize = exports.DISC = void 0;
exports.DISC = '•';
const capitalize = (s) => s.slice(0, 1).toUpperCase() + s.slice(1);
exports.capitalize = capitalize;
const decapitalize = (s) => s.slice(0, 1).toLowerCase() + s.slice(1);
exports.decapitalize = decapitalize;
const latinizeMap = { ł: 'l', Ł: 'L' };
const latinize = (s) => s.replace(/[^\s\w-]/gu, (match) => latinizeMap[match] ||
    match.normalize('NFD').replace(/[\u0300-\u036F]/gu, ''));
exports.latinize = latinize;
const toSnakeCase = (s) => (0, exports.latinize)(s)
    .replace(/[^A-Z_a-z-]/gu, '')
    .replace(/-/gu, '_')
    .replace(/([a-z])([A-Z])/gu, '$1_$2')
    .toLowerCase();
exports.toSnakeCase = toSnakeCase;
const toKebabCase = (s) => (0, exports.toSnakeCase)(s).replace(/_/gu, '-');
exports.toKebabCase = toKebabCase;
const toCamelCase = (s) => (0, exports.latinize)(s)
    .replace(/[^\sA-Z_a-z-]/gu, '')
    .replace(/[\s_-]+([A-Za-z])/gu, (_, g1) => g1.toUpperCase());
exports.toCamelCase = toCamelCase;
const toPascalCase = (s) => (0, exports.capitalize)((0, exports.toCamelCase)(s));
exports.toPascalCase = toPascalCase;
function slugify(s, keepTrailingDash) {
    let result = (0, exports.latinize)(s.toLowerCase())
        .replace(/[/\s_?-]+/gu, '-')
        .replace(/^-/u, '');
    if (!keepTrailingDash) {
        result = result.replace(/-$/u, '');
    }
    return result;
}
exports.slugify = slugify;
function multiplyCssValue(n, v = '0') {
    return /^0(\w+)?$/u.test(v)
        ? v
        : /^(calc)?\(/u.test(v)
            ? `${n} * ${v.replace('calc', '')}`
            :
                v.replace(/\d+(\.\d+)?/u, (Number.parseFloat(v) * n).toString());
}
exports.multiplyCssValue = multiplyCssValue;
function getTerminalLength(str) {
    return str.replace(/\u001B\[\d+m/gu, '').length;
}
exports.getTerminalLength = getTerminalLength;
function digits(str, n) {
    const parsedIntStr = Number.parseInt(String(str)).toString();
    return toLength(parsedIntStr, n, true, '0');
}
exports.digits = digits;
function toLength(str, n, before, char) {
    const spcs = spaces(Math.max(0, n - getTerminalLength(str)), char);
    return before ? `${spcs}${str}` : `${str}${spcs}`;
}
exports.toLength = toLength;
function spaces(n, char = ' ') {
    return Array.from({ length: n }).fill(char).join('');
}
exports.spaces = spaces;
function plural(count, pluralWord) {
    return count === 1
        ? `1 ${pluralWord.replace(/ies$/u, 'y').replace(/e?s$/u, '')}`
        : `${count} ${pluralWord}`;
}
exports.plural = plural;
function pluralize(word) {
    return `${word.replace(/y$/u, 'ie').replace(/s$/u, 'se')}s`;
}
exports.pluralize = pluralize;
function buildDynamicText(text, variables) {
    return text.replace(/\[(.*?)\]/gmu, (_match, param) => {
        var _a;
        return (_a = variables === null || variables === void 0 ? void 0 : variables[param]) !== null && _a !== void 0 ? _a : param;
    });
}
exports.buildDynamicText = buildDynamicText;
function splitEscapedString(string, byChars) {
    return string
        .split(/\\{2}/u)
        .map((group) => group.split(new RegExp(`(?<!\\\\)[${byChars}]`, 'u')))
        .reduce((g1, g2) => {
        const last = g1.length - 1;
        return last >= 0
            ? [...g1.slice(0, -1), `${g1[last]}\\\\${g2[0]}`, ...g2.slice(1)]
            : g2;
    });
}
exports.splitEscapedString = splitEscapedString;
function unnest(code = '') {
    const nesting = code
        .split('\n')
        .filter((line) => Boolean(line.trim()))
        .map((line) => line.trim() ? line.replace(/\S.+$/gmu, '').length : Infinity)
        .reduce((a, b) => Math.min(a, b), Infinity);
    return code
        .split('\n')
        .map((line) => line.slice(nesting).replace(/\s+$/u, ''))
        .join('\n')
        .trim();
}
exports.unnest = unnest;
function sqlString(value) {
    return `'${sqlEscape(value)}'`;
}
exports.sqlString = sqlString;
function sqlEscape(value) {
    return value.replaceAll("'", "''");
}
exports.sqlEscape = sqlEscape;
